const initialState = {
  resumeFaculty:{
    data:[],
    loading:false,
    succes:false,
    error:null,
  },
  resumeCareer:{
    data:[],
    loading:false,
    succes:false,
    error:null,
  },
  resumeCriterias:{
    data:[],
    evaluacionGeneral: null,
    loading:false,
    success:false,
    error:null,
  },
  planMejora:{
    data:[],
    loading:false,
    success:false,
    error:null,
  }
};


const overviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_FACULTADES_RESUME_REQUEST":
      return {
        ...state,
        resumeFaculty: { ...state.resumeFaculty, loading: true, error: null },
      };
    case "GET_FACULTADES_RESUME_SUCCESS":
      return {
        ...state,
        resumeFaculty: { ...state.resumeFaculty, data: action.payload, loading: false, error: null },
      };
    case "GET_FACULTADES_RESUME_FAIL":
      return {
        ...state,
        resumeFaculty: { ...state.resumeFaculty, data: [], loading: false, error: action.payload },
      };

    case "GET_CARRERAS_EVALUACIONES_REQUEST":
      return {
        ...state,
        resumeCareer: { ...state.resumeCareer, loading: true, error: null },
      };
    case "GET_CARRERAS_EVALUACIONES_SUCCESS":
      return {
        ...state,
        resumeCareer: { ...state.resumeCareer, data: action.payload, loading: false, error: null },
      };
    case "GET_CARRERAS_EVALUACIONES_FAIL":
      return {
        ...state,
        resumeCareer: { ...state.resumeCareer, data: [], loading: false, error: action.payload },
      };
    
    case "GET_CRITERIOS_EVALUACIONES_REQUEST":
      return {
        ...state,
        resumeCriterias: { ...state.resumeCriterias, loading: true, error: null, evaluacionGeneral: null },
      };
    case "GET_CRITERIOS_EVALUACIONES_SUCCESS":
      return {
        ...state,
        resumeCriterias: {
          ...state.resumeCriterias,
          data: action.payload.Evaluaciones ?? [],
          evaluacionGeneral: action.payload?.EvaluacionGeneralId
            ? {
                id: action.payload.EvaluacionGeneralId,
                observacion: action.payload?.EvaluacionGeneralObservacion || null,
              }
            : null,
          loading: false,
          error: null,
        },
      };
    case "GET_CRITERIOS_EVALUACIONES_FAIL":
      return {
        ...state,
        resumeCriterias: { ...state.resumeCriterias, data: [], evaluacionGeneral: null, loading: false, error: action.payload },
      };

    case "GET_PLAN_MEJORA_REQUEST":
      return {
        ...state,
        planMejora: { ...state.planMejora, loading: true, error: null },
      };
    case "GET_PLAN_MEJORA_SUCCESS":
      return {
        ...state,
        planMejora: { ...state.planMejora, data: action.payload, loading: false, error: null },
      };
    case "GET_PLAN_MEJORA_FAIL":
      return {
        ...state,
        planMejora: { ...state.planMejora, data: [], loading: false, error: action.payload },
      };

    case 'PROCESS_CHANGED_CLEAR_STATE':
    case 'PERMISSION_CHANGED_CLEAR_STATE':
      return { ...initialState };
      
    default:
      return state;
  }
};

export default overviewReducer;
